export const BILL_LOCATION_VALUES = ['chanthaburi', 'chumphon'] as const
export type BillLocationValue = (typeof BILL_LOCATION_VALUES)[number]

export const BILL_LOCATION_LABELS: Record<BillLocationValue, string> = {
  chanthaburi: 'จันทบุรี',
  chumphon: 'ชุมพร',
}
